import React from "react";
import { useTranslation } from "react-i18next";

const CustomTermPoints = ({ title }) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <div className={`${isRTL ? "text-right" : "text-left"} md:ms-4 ms-2 `}>
      <ul className="list-disc list-outside ps-5">
        <li className="text-lg leading-relaxed text-black">{title}</li>
      </ul>
    </div>
  );
};

export default CustomTermPoints;
